// src/components/SignUpPage.js
import React from "react";
import SignUp from "./SignUp";
import { useNavigate } from "react-router-dom";

const SignUpPage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="page-content">
        <SignUp navigate={navigate} />
      </div>
    </div>
  );
};

export default SignUpPage;
